import React from 'react';

const ComposeVC = () => {
    return (
        <h1 style={{color: "black", fontSize: "50px"}}>
            jwhebhjegjgrjhtvthyvrthbrt 
        </h1>
    );
}

export default ComposeVC;
